import React from "react";
import PrimaryGreenButton from "../../components/button/PrimaryGreenButton";
import check from "../../assets/images/icon/check.svg";
import { useNavigate } from "react-router-dom";
import SuccessStyle from "../../assets/images/success-style.png";

export default function RedeemGiftMemberSuccessCat({ detail }) {
  const navigate = useNavigate();
  const isStamp = detail["isStamp"];

  function detailRow(text1, text2, line = 2) {
    return (
      <div className={`grid grid-cols-${line} text-white`}>
        <div className="text-[16px] font-[600]">{text1}</div>
        <div className={`text-[20px] font-[400] ${line === 2 && "text-right"}`}>
          {text2}
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        style={{
          minHeight: "calc(100vh - 60px)",
          padding: "20px",
          background: "linear-gradient(129.17deg, #213468 22.83%, #213468 36.49%, #1D4164 41.4%, #15645A 50.69%, #079D4A 63.25%, #07A14A 63.8%, #07A14A 77.45%)",

        }}
      >
        <img
          src={SuccessStyle}
          alt="logo"
          style={{ width: "70%", float: "right" }}
          className="mt-[-20px] mr-[-20px]"
        />
        <div className="w-full" style={{
          position: "fixed",
          left: "50%",
          transform: "translate(-50%, 0)"
        }}>
          <div className="px-5 leading-7">
            <div className="text-center">
              <img src={check} alt="error icon" className="inline-block py-5" />
              {isStamp ? (
                <div className="text-[36px] text-white">
                  รับสิทธิ์เรียบร้อยแล้ว
                </div>
              ) : (
                <div className="text-[36px] text-white">
                  แลกของรางวัลเรียบร้อยแล้ว
                </div>
              )}

              <div className="text-[24px] text-white">{detail["name"]}</div>
              <img
                src={detail["urlPicture"]}
                alt="redeem image"
                className="w-1/2 inline-block py-5"
              />
            </div>
            <div className="text-[24px] text-white leading-[100%]">
              รายละเอียด
            </div>
            <hr className="text-green my-2" />
            {detailRow("รหัสรางวัล:", detail["code"])}
            {detailRow("วันที่/เวลาแลกของรางวัล:", detail["createdDate"])}
            {!isStamp &&
              detailRow("Coin ที่ใช้:", `${detail["points"]} คะแนน`)}

            {!isStamp && detailRow("สถานที่จัดส่ง:", detail["address"], 1)}
          </div>
          <div className="text-center py-10">
            <PrimaryGreenButton
              variant="contained"
              className="w-[70%] !bg-[#082e683d]"
              sx={{
                border: '1px solid #FFFFFF',
              }}
              onClick={() => {
                navigate("/redeem-gift-member-cat");
              }}
            >
              เสร็จสิ้น
            </PrimaryGreenButton>
          </div>
        </div>
      </div>

    </>
  );
}
